import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import authentication from "@irati/auth"
import {FormattedMessage} from "@irati/utils/lang"
import Hr from "@irati/ui/src/Layout/Hr"
import {H3} from "@irati/ui/src/Headings"
import {Para} from "@irati/ui/src/Labels"
import {ButtonsWrapper, GetStarted} from "../styled/Buttons"
import {List, Item, ItemContent as ItemContentBase, ItemNumber} from "../styled/List"
import {SlideWrapper} from "../styled/Slider"

const ItemContent = styled(ItemContentBase)`
  padding-top: 5px;
  margin-bottom: 5px;
`

const Step3 = ({onNext}) => {
  const step2Text = authentication.apps("recognition.poll.create")
    ? "recognition.onboarding.step3.item2"
    : "recognition.onboarding.step3.voteInPoll"

  return (
    <SlideWrapper>
      <header>
        <H3 className="text-center">
          <FormattedMessage id="recognition.onboarding.step3.header" />
        </H3>
        <Hr />
      </header>
      <List>
        <Item>
          <ItemNumber>1</ItemNumber>
          <ItemContent>
            <FormattedMessage id="recognition.onboarding.step3.item1" />
          </ItemContent>
        </Item>
        <Item>
          <ItemNumber>2</ItemNumber>
          <ItemContent>
            <FormattedMessage id={step2Text} />
          </ItemContent>
        </Item>
        <Item>
          <ItemNumber>3</ItemNumber>
          <ItemContent>
            <FormattedMessage id="recognition.onboarding.step3.item3" />
          </ItemContent>
        </Item>
      </List>
      <Para>
        <FormattedMessage id="recognition.onboarding.step3.p1" />
      </Para>
      <ButtonsWrapper>
        <Hr />
        <GetStarted onClick={onNext} />
      </ButtonsWrapper>
    </SlideWrapper>
  )
}

Step3.propTypes = {
  onNext: PropTypes.func.isRequired
}

export default Step3
